import config from 'config'
import { formatDate } from '../_helpers/formatDate'
import { isMeinBuero } from '@/utils/build-env'

const isMeinbuero = isMeinBuero()
const urlPrefix = `${config.resourceHost}finance`

export default {
  accountantExportUrl: `${config.resourceHost}accountantExport/`,
  taxSettingsUrl: '/settings/mycompany#tax',

  exportTypes: {
    DATEV: 'DATEV',
    DOCUMENTS: 'DOCUMENTS',
  },

  columns: [
    {
      width: 90,
      field: 'createdAt',
      headerName: 'Datum',
      sort: false,
      suppressMovable: true,
      valueFormatter: ({ value }) => {
        return formatDate(value)
      },
      cellStyle: { display: 'flex', alignItems: 'center', paddingRight: 0 },
    },
    {
      width: 170,
      field: 'exportPeriod',
      headerName: 'Exportzeitraum',
      sort: false,
      suppressMovable: true,
      cellStyle: { display: 'flex', alignItems: 'center', paddingRight: 0 },
    },
    {
      width: 280,
      field: 'content',
      headerName: 'Inhalte',
      sort: false,
      suppressMovable: true,
      cellRenderer: 'contentCell',
      cellStyle: { display: 'flex', alignItems: 'center', paddingRight: 0, wordBreak: 'unset' },
      autoHeight: true,
      wrapText: true,
    },
    {
      width: 140,
      field: '',
      headerName: 'Aktionen',
      sort: false,
      suppressMovable: true,
      cellRenderer: 'actionCell',
      cellStyle: { display: 'flex', alignItems: 'center', paddingRight: 0 },
    },
  ].map((column) => ({ ...column, menuTabs: [] })),
}

export const urls = {
  resource: urlPrefix,
  getBookedFinanceFormModulesUrl: () => `${urlPrefix}/financeform-modules`,
  datevFaq: isMeinbuero ? 'https://www.buhl.de/go/28793' : 'https://info.orgamax.de/faq-orgamax-buchhaltung/steuerberater-export-datev-cloud-services',
}
